import { KycVerificationStatus } from "@scrile/api-provider/dist/api/KycPropertiesProvider";

export const allowIdentityAccess = (status: KycVerificationStatus) =>
  status !== KycVerificationStatus.UNDER_VERIFICATION;
